export const VISUALIZED = { value: "VISUALIZED" };
export const NOT_VISUALIZED = { value: "NOT_VISUALIZED" };

export default [VISUALIZED, NOT_VISUALIZED];



// WEBPACK FOOTER //
// ./src/components/common/enums/invoiceVisualizeStatusType.js